import { createContext } from 'react';
import { App, Image, Samples, SampleItem, Thresholds } from '@types';
import { LocalStorage, Image as ImageUtils, Url } from '@utils';

// default to using hardcoded images, hide unsplash via url param for now:
const useStaticSamples = Url.getParam('src') !== 'UNSPLASH'.toLowerCase();

// This must annoyingly exist BEFORE we define defaultGlobalCtx below
export const defaultEmptyImage = {
  isImporting: false,
  isUpdating: false,
  isUploading: false,
};

export interface GlobalCtxProps {
  app: App;
  image?: Image;
  samples?: Samples;
  setApp: (app: App) => void;
  setImage: (image: Image) => void;
  setSamples: (samples: Samples) => void;
}

export const defaultGlobalCtx: GlobalCtxProps = {
  app: {
    clientId: LocalStorage.getOrGenerateClientId(),
    bandwidth: 'LOW',
    layout: 'SIDE_BY_SIDE',
    notice: {
      isVisible: false,
      type: 'ERROR',
    },
    modal: {
      isVisible: false,
    },
    thresholds: {
      low: 30,
      high: 100,
    },
  },
  image: LocalStorage.getImage(),
  samples: {
    src: useStaticSamples ? 'STATIC' : 'UNSPLASH',
    items: useStaticSamples ? ImageUtils.buildStaticSamples() : LocalStorage.getSamples(),
  },
  /* tslint:disable */
  // (tslint does not like the empty objects)
  setApp: (app: App) => {},
  setImage: (image: Image) => {},
  setSamples: (samples: Samples) => {},
  /* tslint:enable */
};

const GlobalCtx = createContext<GlobalCtxProps>(defaultGlobalCtx);

export default GlobalCtx;
